import { ChangeEvent, useCallback } from 'react';

import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { getCell } from '../../../../utils/table';
import { EditableCellProps } from '../../Table.proptype';

const useStyles = makeStyles({
  box: {
    display: 'flex',
    justifyContent: 'center'
  }
});

const EditableCheckboxCell = ({
  column,
  row,
  onCellOrCommentBlur
}: Pick<EditableCellProps, 'column' | 'row' | 'onCellOrCommentBlur'>) => {
  const { asc740 } = useFlags();
  const classes = useStyles();
  const value = getCell(row, column);

  // Check if the cell is editable (only used when asc740 is true)
  const isEditable =
    typeof column.isEditable === 'function' ? (column.isEditable as any)(row) : Boolean(column.isEditable);

  const onCheckedIfEditable = useCallback(
    (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (isEditable) {
        onCellOrCommentBlur?.({
          value: checked ? 1 : 0,
          row,
          column
        });
      }
    },
    [onCellOrCommentBlur, row, column, isEditable]
  );

  return asc740 ? (
    <Box className={classes.box}>
      <Checkbox checked={Boolean(value)} disabled={!isEditable} onChange={onCheckedIfEditable} />
    </Box>
  ) : null;
};

export default EditableCheckboxCell;
